<template>
    <component
        :is="display"
        :resource="resource"
        :elasticsearch="elasticsearch"
    />
</template>

<script setup>
import { computed } from "vue";
import { useUser } from "@/Composables";
import MarketingContent from "@/Themes/Marketing/Components/Modules/Cards/ResourceCard.vue";
import SourcingContent from "@/Themes/Sourcing/Components/Modules/Cards/ResourceCard.vue";

const props = defineProps({
    resource: {
        type: Object,
        required: true,
    },
    elasticsearch: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const { settings } = useUser();
const display = computed(() =>
    settings.value.is_sourcing_mode ? SourcingContent : MarketingContent
);
</script>
